import React from 'react'
import './About.css'
import play_icon from '../../assets/play-icon.png';
import about_img from '../../assets/about.png';

const About = ({setPlayState}) => {
  return (
    <div className='about'>
      <div className="about-left">
        <img src={about_img} alt="" className='about-img' />
         <img src={play_icon} alt="" className='play-icon' onClick={()=>{setPlayState(true) }}/>
      </div>
      <div className="about-right">
        <h3>ABOUT NORTH STAR ENGINEERING</h3>
        <h2>Missin And Vision</h2>
        <p>North Star Engineering (Pvt.) Ltd (NSE) was established in December-2017
            under the Companies Act, 2017 (XIX of 2017) of Security Exchange
            Commission of Pakistan with an objective to provide appropriate technical &
            economic solutions for Oil & Gas, Petrochemicals, Power, Wind Farms, and
            various other industrial projects.
        </p>
        <p>North Star Engineering (Pvt.) Ltd offers a full range of services that includes
            Project Development, Front End Engineering Design, Detailed Engineering,
            Project Management and Construction Supervision Services, Procurement
            Assistance, and Pre- commissioning and commissioning assistance.</p>
            <p>NSEL is a pioneer of many innovative military style construction, engineering
                and project management techniques. Our expert civil and construction project
                delivery experience ensures we are the preferred contractor for many clients
                across a vast array of industry sectors.</p>
                <p>Our wide spectrum of services also includes professional interior designing. Our
                    focus on high quality design intends to use the maximum of our skills. This gives
                    us the opportunity to invent and use new technologies.</p>
        <p>North Star Engineering has a storng team to design and execute ECP Projects 
        </p>
        <p>We have vision to Customer satisfaction </p>
      </div>
    </div>
  )
}

export default About
